import Home from './Home'

export const items = [
  {
    path: '/sala-de-situacao/home',
    name: 'sala-de-situacao/home',
    component: Home
  }
]



// WEBPACK FOOTER //
// ./src/screens/sala_situacao/config.js